/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */

app.controller('Recipients', function($scope, recipientService, $log, $state, $rootScope, _$privileges,$http,_$toast) {
    $scope.rows = [];
    $scope.channels = [];
    $scope.notifications = ["email", "epuap", "sms", "mobile"];

    $scope.showLoader = true;

    $scope.data = {
        "can_write": _$privileges.write("receiver"),
        "activeNotifications": []
    };

    /*
     * pagination
     */

    $scope.pagination = {
        currentPage: 1,
        totalItems: 1,
        itemsPerPage: 1
    };

    $scope.setPage = function() {
        $scope.showLoader = true;
        $scope.list.request($scope.pagination.currentPage);
    };

    /*
     * list
     */

    $scope.listReady = false;
    $scope.list = {
        "first": 0,
        "setResponseParams": function(data) {
            $scope.rows = data.list.data;
            $scope.channels = data.channels;
            $scope.notifications = ['email','epuap','sms','mobile'];
            $scope.data.activeNotifications = data.activeNotifications;            
            $scope.pagination = {
                totalItems: data.list.total,
                currentPage: data.list.current_page,
                itemsPerPage: data.list.per_page
            };
            if ($scope.list.first == 0) {
                $scope.list.first = 1;
            }
            $scope.subunitSupported = data.subunitSupported;
            $scope.teamSupported = data.teamSupported;
        },
        "request": function(page) {
            var params = typeof $scope.search != "undefined" ? angular.copy($scope.search.model) : {};

            if (typeof params.city !== "undefined" && params.city.length > 0)
                params.city = _.map(params.city, 'name').join();
            if (typeof params.county !== "undefined" && params.county.length > 0)
                params.county = _.map(params.county, 'name').join();
            if (typeof params.comunity !== "undefined" && params.comunity.length > 0)
                params.comunity = _.map(params.comunity, 'name').join();
            if (typeof params.street !== "undefined" && params.street.length > 0)
                params.street = _.map(params.street, 'name').join();

            if (typeof params.unit_id != "undefined" && params.unit_id.length > 0)
                params.unit_id = params.unit_id.join();
            if (typeof params.team_id != "undefined" && params.team_id.length > 0)
                params.team_id = params.team_id.join();
            var promise = recipientService.list(page, params);
            promise.then(
                function(payload) {
                    $scope.list.setResponseParams(payload.data);
                    $scope.showLoader = false;
                    $scope.listReady = true;
                },
                function(errorPayload) {
                    $log.error('Błąd ładowania odbiorców', errorPayload);
                    $scope.showLoader = false;
                });
        }
    };

    $rootScope.checkboxList.clear();
    $scope.list.request(1);

    /*
     * filters
     */

    $scope.filtering = {
        set: function() {
            var promise = recipientService.filters();
            promise.then(
                function(payload) {
                    $rootScope.filters = payload.data;
                },
                function(errorPayload) {
                    $log.error('Błąd ładowania filtrów', errorPayload);
                }
            );
        },
        run: function() {
            var params = typeof $scope.search != "undefined" ? angular.copy($scope.search.model) : [];

            if ($scope.search.model.city.length > 0)
                params.city = _.map($scope.search.model.city, 'name').join();
            if ($scope.search.model.county.length > 0)
                params.county = _.map($scope.search.model.county, 'name').join();
            if ($scope.search.model.comunity.length > 0)
                params.comunity = _.map($scope.search.model.comunity, 'name').join();
            if ($scope.search.model.street.length > 0)
                params.street = _.map($scope.search.model.street, 'name').join();

            if (typeof params.unit_id != "undefined" && params.unit_id.length > 0)
                params.unit_id = params.unit_id.join();

            if (typeof params.team_id != "undefined" && params.team_id.length > 0)
                params.team_id = params.team_id.join();

            $scope.showLoader = true;

            var promise = recipientService.list(1, params);
            promise.then(
                function(payload) {
                    $scope.showLoader = false;
                    $scope.list.setResponseParams(payload.data);
                },
                function(errorPayload) {
                    $scope.showLoader = false;
                    $rootScope.notification.show('error', 'Błąd ładowanie odbiorców');
                }
            );
        }
    };

    $scope.filtering.set();

    /*
     * search
     */

    $scope.search = {
        "clearButton": false,
        "clearButtonPressed": false,
        "all": true,
        "changeKind": function() {
            $scope.search.model.age = '';
        },
        "model": {
            sex: '',
            name: '',
            surname: '',
            comunity: [],
            city: [],
            county: [],
            postcode: '',
            street: [],
            age: '',
            age_before: '',
            age_after: '',
            kind: '',
            unit_id: [],
            team_id: []
        },
        clear: function() {
            if ($scope.search.all) {
                $scope.search.empty();
                $scope.list.request(1);
                $scope.search.clearButton = false;
            }
        },
        clearFilters: function() {
            if ($scope.search.model.kind == 'advanced') {
                $scope.search.empty();
                $scope.search.clearButton = false;
                $scope.search.clearButtonPressed = true;
            }
        },
        empty: function() {
            $scope.search.model.sex = '';
            $scope.search.model.name = '';
            $scope.search.model.surname = '';
            $scope.search.model.comunity = [];
            $scope.search.model.street = [];
            $scope.search.model.city = [];
            $scope.search.model.county = [];
            $scope.search.model.postcode = '';
            $scope.search.model.age = '';
            $scope.search.model.age_before = '';
            $scope.search.model.age_after = '';
            $scope.search.model.unit_id = [];
            $scope.search.model.team_id = [];
        }
    };


    $scope.$watch('search.model', function(newValue, oldValue) {
        if ($scope.listReady && $scope.search.model.kind == 'advanced' && newValue.kind == oldValue.kind && !$scope.search.clearButtonPressed) {
            $scope.search.clearButton = true;
        } else {
            $scope.search.clearButtonPressed = false;
            $scope.search.clearButton = false;
        }
    }, true);

    $scope.panel = {
        "show": function() {

        },
        "concate": function() {
            var ids = [];
            for (var i = 0; i < $scope.rows.length; i++) {
                if ($scope.rows[i].checked)
                    ids.push($scope.rows[i].id);
            }
            return ids;
        },
        "renewMobileCode": function() {
            var ids = $scope.panel.concate();
            if (ids.length > 1) {
                $rootScope.notification.show('error', "Wybierz pojedynczego odbiorcę");
            } else {
                var promise = recipientService.renewMobileCode($scope.panel.concate());
                promise.then(
                    function(payload) {
                        if (payload.data.code) {
                            $rootScope.notification.show('success', payload.data.msg);
                            $scope.list.request($scope.pagination.currentPage);
                            $rootScope.checkboxList.clear();
                        } else {
                            $rootScope.notification.show('error', payload.data.msg);
                        }
                    });
            }
        },
        "spam": function() {
            var promise = recipientService.spam($scope.panel.concate());
            promise.then(
                function(payload) {
                    if (payload.data.code) {
                        $rootScope.notification.show('success', payload.data.msg);
                        $scope.list.request($scope.pagination.currentPage);
                        $rootScope.checkboxList.clear();
                    } else {
                        $rootScope.notification.show('error', payload.data.msg);
                    }
                });
        },
        "activate": function() {
            var promise = recipientService.activate($scope.panel.concate());
            promise.then(
                function(payload) {
                    if (payload.data.code) {
                        $rootScope.notification.show('success', payload.data.msg);
                        $scope.list.request($scope.pagination.currentPage);
                        $rootScope.checkboxList.clear();
                    } else {
                        $rootScope.notification.show('error', payload.data.msg);
                    }
                });
        },
        "verify": function() {
            var promise = recipientService.verify($scope.panel.concate());
            promise.then(
                function(payload) {
                    if (payload.data.code) {
                        $rootScope.notification.show('success', payload.data.msg);
                        $scope.list.request($scope.pagination.currentPage);
                        $rootScope.checkboxList.clear();
                    } else {
                        $rootScope.notification.show('error', payload.data.msg);
                    }
                });
        },
        "delete": function() {
            $scope.showLoader = true;

            var promise = recipientService.delete($scope.panel.concate());
            promise.then(
                function(payload) {
                    if (payload.data.code) {
                        $scope.showLoader = false;
                        $rootScope.notification.show('success', payload.data.msg);
                        $scope.list.request(1);
                        $rootScope.checkboxList.clear();
                    } else {
                        $scope.showLoader = false;
                        $rootScope.notification.show('error', payload.data.msg);
                    }
                });
        },
        "sendmsg": function() {
            $state.go('message_msgnewids', {
                ids: $scope.panel.concate()
            });
        }
    };

    $scope.hasNotification = function(current, users) {
        var has = false;
        for (var i = 0; i < users.length; i++) {
            if (current == users[i].symbol) {
                has = true;
            }
        }
        return has;
    };

    $scope.changeAge = function() {
        $scope.search.model.age_after = "";
        $scope.search.model.age_before = "";
    };

    $scope.importDocs = function() {
        $scope.showLoader = true;
        $http.post('/administration/settings/importepuapdocs')
            .success(function(result) {
                $scope.showLoader = false;
                if (result.code == 2)
                    _$toast.message(result.msg);
                else{
                    if(result.code)
                      $scope.list.request(1);
                    $rootScope.notification.show(result.code ? 'success' : 'error', result.msg);
                }
            }).error(function() {
                $scope.showLoader = false;
                $rootScope.notification.show('error', 'Import dokumentów nie powiódł się');
            });
    };

    $scope.printClear = function(id) {
        var promise = recipientService.printpdfclear();
        promise.then(
            function(payload) {
                if (payload.data == "")
                     $rootScope.notification.show(0, "Nie udało się wygenerować pliku wydruku");
                else {
                     top.location.href = "/downloadpdf/" + payload.data;
                }
            });
    };
});
